export const PRICING_PAGE = {
  cycleToggle: 'pricing-cycle-toggle',
  tierCard: 'pricing-tier-card',
  ctaButton: 'pricing-cta-button',
  navLink: 'landing-pricing-link',
};

export const DEMO_PAGE = {
  navLink: 'landing-demo-link',
  nextButton: 'demo-next-button',
  prevButton: 'demo-prev-button',
  stepDot: 'demo-step-dot',
  ctaButton: 'demo-cta-button',
};

export const PRIVACY_PAGE = {
  content: 'privacy-policy-content',
  footerLink: 'footer-privacy-link',
};

export const ACUERDO_PAGE = {
  content: 'acuerdo-page-content',
  unpublishedNotice: 'acuerdo-page-unpublished-notice',
  footerLink: 'footer-acuerdo-link',
};

export const TERMS_PAGE = {
  content: 'terms-page-content',
  unpublishedNotice: 'terms-page-unpublished-notice',
  footerLink: 'footer-terms-link',
};

export const FAQ_PAGE = {
  content: 'faq-page-content',
  footerLink: 'footer-faq-link',
};

export const BILLING_PAGE = {
  navLink: 'admin-nav-billing',
  statusBadge: 'billing-status-badge',
  currentPlanCard: 'billing-current-plan-card',
  subscribeButton: 'billing-subscribe-button',
  manageButton: 'billing-manage-button',
  cycleSelect: 'billing-cycle-select',
  gracePeriodBanner: 'billing-grace-period-banner',
  readOnlyBanner: 'billing-read-only-banner',
  demoAccountNote: 'billing-demo-account-note',
};
